import { siteBaseUrl } from "@/utils/baseUrl";

/**
 * Default 1200x630 social share image (headshot card) used for Open Graph /
 * Twitter cards on pages without a page-specific image.
 */
export const defaultOgImage =
  "https://imagedelivery.net/dZMNLiwpNY0_jKeBRDZ4_g/ef483dd6-29df-45a9-8ef8-645791777100/public";

/** Stable JSON-LD @id so every page's Person references the same entity. */
export const personJsonLdId = `${siteBaseUrl.origin}/#person`;
export const businessJsonLdId = `${siteBaseUrl.origin}/#business`;
export const servBuilderOrgId = "https://www.servbuilder.com/#organization";

export const andrewIdentity = {
  name: "Andrew Leger",
  url: siteBaseUrl.origin,
  github: "https://github.com/aleger",
  linkedin: "https://www.linkedin.com/in/andrewleger/",
  twitter: "https://twitter.com/andrewleger",
  twitterHandle: "@andrewleger",
  jobTitle: "Engineering Leader and AI Developer",
  description:
    "Independent engineering leader and developer in Omaha, NE, working through AJLDev, LLC. Builds AI products and AI-powered software for small companies: fractional engineering and AI leadership, websites with AI features, and custom LLM apps, agents, and automations. Founder of ServBuilder.",
  sameAs: [
    "https://www.linkedin.com/in/andrewleger/",
    "https://twitter.com/andrewleger",
    "https://github.com/aleger",
  ],
  knowsAbout: [
    "Artificial intelligence",
    "AI systems architecture",
    "Large language model (LLM) applications",
    "OpenAI API integration",
    "AI agents and multi-agent orchestration",
    "AI automation",
    "Machine learning and predictive analytics",
    "AI in the software development lifecycle (AI SDLC)",
    "AI adoption for engineering teams",
    "Fractional engineering leadership",
    "Engineering management",
    "Website development",
    "Custom software development",
    "Next.js",
    "TypeScript",
    "Postgres",
    "Azure DevOps",
    "Jira",
    "Agile delivery",
  ],
} as const;
